export const GENERIC_ERROR_MESSAGE = 'Error sending password reset link';

// TODO check if we want to change this message or even keep it
export const UNREGISTERED_EMAIL_MESSAGE =
  'The provided email is not registered with Headliner';
